import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionList"] */ "/vercel/path0/src/components/atoms/Accordion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/atoms/Button/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Container/Container.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/atoms/Date/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Typography/Typography.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Flex/Flex.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Grid/Grid.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Error/Error.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Tag/Tag.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/ApplyLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/BoxInfo/BoxInfo.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/molecules/BoxList/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/Hero/HeroImage.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/EntitiesList/EntityItem/EntityItem.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/Competition/CompetitionCard/CompetitionCard.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/Competition/CompetitionSidebar/CompetitionSidebar.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/Competition/CompetitionMain/CompetitionMain.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/molecules/Hero/HeroMain.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/molecules/NotActiveCompetition/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/vercel/path0/src/components/molecules/Toast/context/ToastProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/organisms/Hero/Hero.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/GridRow/GridRow.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/GridColumn/GridColumn.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/About/About.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Icon/Icon.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/atoms/Section/Section.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/ContentWithSteps/Steps.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/organisms/ContentWithSteps/ContentWithSteps.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/organisms/BoxesList/BoxesList.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/organisms/EntitiesList/EntitiesList.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/molecules/GeneralInfo/GeneralInfo.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/organisms/GeneralInfos/GeneralInfos.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/organisms/Materials/Materials.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/organisms/PageBody/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/organisms/ShareBox/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/contexts/PublicCompetitionContext.tsx");
